import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { createGlobalStyle } from "styled-components";
import HelmetWrapper from "./HelmetWrapper/HelmetWrapper";
import Header from "./Header/Nav";
import Footer from "./Footer/Footer";
import AdobeDynamicTagManagement from "../modernized/Analytics/AdobeDynamicTagManager";
import GoogleTagManager from "../modernized/Analytics/GoogleTagManager";
import zIndex from "../../styles/z-indexes";

const GlobalStyle = createGlobalStyle`
      body {
        box-sizing: border-box;
        font-family: effra, sans-serif;
        color: #262626;
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 20px;
        overflow-x: hidden;
        overflow-y: scroll;
        background-color: #fff;
      }
      a {
            cursor: pointer;
            text-decoration: none;
            color: inherit;
        
            &:hover {
                text-decoration: underline;
            }
        }
`;

const OverlayDiv = styled.div`
    label: OverlayDiv;

    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: ${zIndex.overlay_main};
    background-color: rgba(33, 33, 33, 0.7);
    opacity: ${(props) => (props.showOverlay ? 1 : 0)};
    pointer-events: ${(props) => (props.showOverlay ? "auto" : "none")};
    transition: all 0.3s;

    //Mobile-landscape (and larger)
    @media (min-width: 320px) {
        display: none;
    }
    //Mobile-landscape (and larger)
    @media (min-width: 480px) {
        display: none;
    }
    // Tablet-portrait (and larger)
    @media (min-width: 768px) {
        display: block;
    }
    // Tablet-landscape (and larger)
    @media (min-width: 992px) {
        display: block;
    }
    // Laptops (and longer)
    @media (min-width: 1200px) {
        display: block;
    }
`;

class TemplateWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            openDropdown: null,
            cartProducts: [],
            cartPrices: [],
            cartCount: 0
        };
    }

    // Lifecycle Methods
    componentDidMount() {
        window.addEventListener("resize", this.resize);
        this.resize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }

    // Custom Methods
    setOpenDropdown = (openDropdown) => {
        this.setState({
            openDropdown
        });
    };

    resize = () => {
        const { openDropdown, isMobile } = this.state;
        const MOBILE_BREAKPOINT = 1079;
        this.setState({
            isMobile: document.body.getBoundingClientRect().width <= MOBILE_BREAKPOINT
        });
        if (!isMobile && openDropdown === "Mobile Nav") {
            this.setState({
                openDropdown: null
            });
        } else if (isMobile && openDropdown === "Languages & Pricing") {
            this.setState({
                openDropdown: null
            });
        }
    };

    overlayClick = () => {
        this.setState({
            openDropdown: null
        });
    };

    render() {
        const { children, copyData, config } = this.props;
        const { openDropdown } = this.state;

        let header = null;

        if (config) {
            if (config.nav.visible) {
                header = (
                    <Header config={config.nav} openDropdown={openDropdown} setOpenDropdown={this.setOpenDropdown} />
                );
            }
        }
        return (
            <div>
                <GlobalStyle />
                {config && config.page ? <HelmetWrapper page={config.page} /> : <HelmetWrapper />}
                {header}
                <OverlayDiv
                    role="menuitem"
                    showOverlay={openDropdown !== null && openDropdown !== "Mobile Nav"}
                    onClick={this.overlayClick}
                />
                {children}
                {config && config.footer && <Footer config={config.footer} />}
                {/* This is only needed for the China Site */}
                {/*  {isCombinedVertical(copyData.market) && ( */}
                {/*      <script */}
                {/*          type="text/javascript" */}
                {/*          dangerouslySetInnerHTML={{ */}
                {/*              __html: ` */}
                {/*                    var rs = {}; */}
                {/*                    var RSUI = { */}
                {/*                      util: {} */}
                {/*                    }; */}
                {/*          }} */}
                {/*      /> */}
                {/*  )} */}
                {config ? (
                    <>
                        <AdobeDynamicTagManagement dtm_url={config.analytics.dtm_url} />
                        <GoogleTagManager gtm_id={config.analytics.gtm_id} />
                    </>
                ) : (
                    <>
                        <AdobeDynamicTagManagement dtm_url={copyData.dtm_url} />
                        <GoogleTagManager gtm_id={copyData.gtm_id} />
                    </>
                )}
            </div>
        );
    }
}

TemplateWrapper.propTypes = {
    config: PropTypes.object,
    children: PropTypes.node,
    vertical: PropTypes.string,
    page: PropTypes.any,
    copyData: PropTypes.any,
    hedPubSubNav: PropTypes.any,
    cnHome: PropTypes.string
};

TemplateWrapper.defaultProps = {
    hedPubSubNav: false
};

export default TemplateWrapper;
